import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddMaterialConsumptionVal = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [Material, setMaterial] = useState([]);
  const [Company, setCompany] = useState([]);
  const [Product, setProduct] = useState([]);
  // console.log(Material)
  const [rowAddData, setRowAddData] = useState({
    value: "",
    stock_limit: "",
  });
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedProductlId, setSelectedProductId] = useState("");

  function resetFileds() {
    setRowAddData({
      value: "",
      stock_limit: "",
    });
    setSelectedProductId("");
    setSelectedMaterialId("");
    setSelectedCompanyId("");
  }

  const handleMaterialChange = (e) => {
    setSelectedMaterialId(e.target.value);
  };

  // const handleCompanyChange = (e) => {
  //   setSelectedCompanyId(e.target.value);
  // };

  const handleProductChange = (e) => {
    setSelectedProductId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { value, stock_limit } = rowAddData;

    let BASE_URL =
      SERVER_URL + `/api/mat-consumption/material-consumption/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        value,
        company_id: selectedCompanyId,
        material_id: selectedMaterialId,
        product_id: selectedProductlId,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
        // formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getMaterial = async () => {
    let BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setMaterial(result.data);
  };

  useEffect(() => {
    getMaterial();
  }, [selectedCompanyId]);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getProduct = async (e) => {
    // console.log(e.target.value)
    setSelectedCompanyId(e.target.value);
    const BASE_URL =
      SERVER_URL + `/api/mat-consumption/drop-material-consumption/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: e.target.value,
      }),
    });
    const result = await res.json();
    setProduct(result.data);
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Material Consumption Value
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getProduct(e)}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {Company &&
                                Company?.length > 0 &&
                                Company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="product_name">Product Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleProductChange}
                              value={selectedProductlId}
                              id="product_name"
                              required
                            >
                              <option value="">Select Product</option>
                              {Product &&
                                Product?.length > 0 &&
                                Product?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="material_name">Material Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleMaterialChange}
                              value={selectedMaterialId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Material</option>
                              {Material &&
                                Material?.length > 0 &&
                                Material?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.material_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="value">Value</label>
                            <input
                              type="number"
                              className="form-control"
                              name="value"
                              id="value"
                              placeholder="Value"
                              onChange={handleChange}
                              value={rowAddData.value}
                              required
                              min="0"
                              step="0.001"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMaterialConsumptionVal;
